import styled from 'styled-components';

import { IncentiveEvaluationMessage } from 'components/incentive-evaluation-messages/incentive-evaluation-messages';

import { IWithIsCatering } from './types';

export const Item = styled.li<IWithIsCatering>`
  margin: 0;
  background-color: ${Styles.color.white};
  color: ${Styles.color.grey.one};
  border-radius: ${Styles.borderRadius};
  display: flex;
  flex-direction: column;
`;

export const ItemOffer = styled.div`
  background-color: ${Styles.color.grey.five};
  border-top-left-radius: ${Styles.borderRadius};
  border-top-right-radius: ${Styles.borderRadius};
  padding: 0.5rem 1rem 0.75rem;

  h2 {
    font-size: 1rem;
    font-weight: ${Styles.fontWeight.heavy};
    margin: 0;
  }

  p {
    font-size: 0.75rem;
  }
`;

export const ItemOfferHeading = styled.span<{ $isApplied: boolean }>`
  font-size: 0.625rem;
  text-transform: uppercase;
  color: ${({ $isApplied }) => ($isApplied ? Styles.color.black : Styles.color.red)};
`;

export const StyledIncentiveEvaluationMessage = styled(IncentiveEvaluationMessage)`
  align-items: flex-start;
`;
